import { useEffect, useState } from "react";
import Layout, { Section, PageHero } from "@/components/layout/Layout";
import { api } from "@/lib/api";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function FAQ() {
    const [faqs, setFaqs] = useState(null);

    useEffect(() => {
        api.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => setFaqs([]));
    }, []);

    const groups = [];
    (faqs || []).forEach((f) => {
        let group = groups.find((g) => g.category === f.category);
        if (!group) {
            group = { category: f.category, items: [] };
            groups.push(group);
        }
        group.items.push(f);
    });

    return (
        <Layout title="FAQ — Ventara" description="Answers to common questions about Ventara's AI services, Sonare, custom software, security, and how we work.">
            <PageHero
                eyebrow="FAQ"
                title={<>Questions,<br />answered plainly.</>}
                lead="Everything we're most often asked about our AI services, Sonare, custom software, security, and how engagements work. Can't find what you need? Get in touch."
            />

            <Section className="pb-32" data-testid="faq-list">
                {!faqs && <p className="prose-body">Loading…</p>}
                {faqs && faqs.length === 0 && <p className="prose-body">No FAQs yet.</p>}
                {groups.map((g) => (
                    <div key={g.category} className="mb-16" data-testid={`faq-group-${g.category.toLowerCase().replace(/\s+/g, '-')}`}>
                        <p className="label mb-6">{g.category}</p>
                        <Accordion type="multiple" className="border-t border-border">
                            {g.items.map((f) => (
                                <AccordionItem key={f.id} value={f.id} className="border-border">
                                    <AccordionTrigger className="font-serif text-xl sm:text-2xl font-light tracking-tight py-6 hover:no-underline" data-testid="faq-question">
                                        {f.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="prose-body text-base" data-testid="faq-answer">
                                        {f.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                ))}
            </Section>
        </Layout>
    );
}
